import { Link, useLocation } from 'react-router-dom'
import { Users, LogOut, Bell, Image, Settings, FileText, BarChart3, MapPin } from 'lucide-react'
import { useAuth } from '../contexts/AuthContext.js'
import { useSidebar } from '../contexts/SidebarContext.js'
import logo from '../assets/logo.svg'
import mobileLogo from '../assets/sidebar-mob-logo.png'

const Sidebar = () => {
  const { logout } = useAuth()
  const { isCollapsed } = useSidebar()
  const location = useLocation()

  const menuItems = [
    {
      name: 'Дашборд',
      path: '/dashboard',
      icon: BarChart3
    },
    {
      name: 'Користувачі',
      path: '/users',
      icon: Users
    },
    {
      name: 'Регіони',
      path: '/regions',
      icon: MapPin
    },
    {
      name: 'Пуш-повідомлення',
      path: '/notifications',
      icon: Bell
    },
    {
      name: 'Баннери',
      path: '/banners',
      icon: Image
    },
    {
      name: 'Статистика',
      path: '/logs',
      icon: FileText
    },
    {
      name: 'Налаштування',
      path: '/settings',
      icon: Settings
    }
  ]

  return (
    <div className={`fixed left-0 top-0 h-screen bg-white shadow-sm border-r border-gray-200 flex-shrink-0 transition-all duration-300 z-40 ${
      isCollapsed ? 'w-16' : 'w-80'
    }`}>
      {/* Logo Section */}
      <div className={`p-6 ${isCollapsed ? 'px-2' : ''}`}>
        <div className="flex items-center justify-center">
          {isCollapsed ? (
            <img src={mobileLogo} alt="EuroMix" className="w-8 h-8 object-contain" />
          ) : (
            <img src={logo} alt="EuroMix" className="w-[70%]" />
          )}
        </div>
      </div>

      {/* Navigation */}
      <nav className="mt-6">
        <div className={`${isCollapsed ? 'px-2' : 'px-3'}`}>
          {menuItems.map((item) => {
            const Icon = item.icon
            const isActive = location.pathname === item.path
            
            return (
              <Link
                key={item.path}
                to={item.path}
                className={`flex items-center rounded-lg mb-1 transition-colors group relative ${
                  isCollapsed ? 'justify-center px-2 py-3' : 'space-x-3 px-3 py-2'
                } ${
                  isActive
                    ? 'bg-gray-900 text-white'
                    : 'text-gray-700 hover:bg-gray-100'
                }`}
                title={isCollapsed ? item.name : ''}
              >
                <Icon size={20} />
                {!isCollapsed && (
                  <span className="font-medium">{item.name}</span>
                )}
                
                {/* Tooltip for collapsed state */}
                {isCollapsed && (
                  <div className="absolute left-full ml-2 px-2 py-1 bg-gray-900 text-white text-sm rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none whitespace-nowrap z-50">
                    {item.name}
                  </div>
                )}
              </Link>
            )
          })}
        </div>
      </nav>

      {/* Logout Button */}
      <div className={`absolute bottom-0 border-t border-gray-200 ${
        isCollapsed ? 'w-16 p-2' : 'w-80 p-4'
      }`}>
        <button
          onClick={logout}
          className={`flex items-center text-gray-700 hover:bg-gray-100 rounded-lg w-full transition-colors group relative ${
            isCollapsed ? 'justify-center px-2 py-3' : 'space-x-3 px-3 py-2'
          }`}
          title={isCollapsed ? 'Вийти' : ''}
        >
          <LogOut size={20} />
          {!isCollapsed && (
            <span className="font-medium">Вийти</span>
          )}
          
          {/* Tooltip for collapsed state */}
          {isCollapsed && (
            <div className="absolute left-full ml-2 px-2 py-1 bg-gray-900 text-white text-sm rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none whitespace-nowrap z-50">
              Вийти
            </div>
          )}
        </button>
      </div>
    </div>
  )
}

export default Sidebar
